<div class="row contenedor-detalle-siniestro mx-0 mt-2 px-0">
    <div class="col-md-6 col-12 col-sm-12 my-3 borde-derecho">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo">PÓLIZA</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class=" col-12 col-md-12 my-4 overflow-auto">
                <div class="seccion-tabla">
                    <table mat-table multiTemplateDataRows [dataSource]="tablaConvenios"
                        class="table d-xl-table d-md-table d-table table-responsive my-2">
                        <ng-container matColumnDef="Alta">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Alta</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.fec_alta_conv}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Inicio">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Inicio</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.fecinic_conv}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Autoriza">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Autoriza</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.nombre_autoriza}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Termino">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Termino</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.fecterc_conv}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Estatus">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Estatus</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_estatus}}</td>
                        </ng-container>

                        <!-- Sin resultados -->
                        <ng-container matColumnDef="noData">
                            <td mat-footer-cell *matFooterCellDef colspan="5">
                                <small>No se encontró ningún resultado</small>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayColumns; sticky : true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="SelectRow(row, 'POLIZA')"
                            [ngClass]="{'highlightTableColor': selectedPolizaRowIndex == row.consecutivo }"> </tr>
                        <tr mat-footer-row *matFooterRowDef="['noData']"
                            [ngClass]="(tablaConvenios?.data?.length === 0) ? '':'ocultarPaginator'"></tr>
                    </table>
                    <mat-paginator #convenio [pageSizeOptions]="[3, 5, 10, 20, 50,100]" showFirstLastButtons
                        [pageSize]="3" [length]="tablaConvenios?.data?.length"
                        aria-label="Select page of periodic elements" [ocultarLabelPagina]="true"
                        [ocultarInputPagina]="true" appOcultaElementosPaginador>
                    </mat-paginator>
                </div>
            </div>
            <div class="col-md-12">
                <span class="contenedor-descripcion-convenio">{{selectPolizaDatos?.texto_conv}}</span>
            </div>
        </div>

    </div>
    <div class="col-md-6 col-12 col-sm-12 my-3">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo limitado">AGENTE: <b>{{agenteNombre}}</b></small>
            </div>
        </div>
        <div class="row mb-2 seccion-tabla">
            <div class="col-12 col-md-12 my-4 overflow-auto">
                <div class="seccion-tabla">
                    <table mat-table multiTemplateDataRows [dataSource]="tablaAgentes"
                        class="table d-xl-table d-md-table d-table table-responsive my-2">
                        <ng-container matColumnDef="Alta">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Alta</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.fec_alta_conv}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Inicio">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Inicio</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.fecinic_conv}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Autoriza">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Autoriza</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.nombre_autoriza}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Termino">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Termino</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.fecterc_conv}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Estatus">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Estatus</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_estatus}}</td>
                        </ng-container>

                        <!-- Sin resultados -->
                        <ng-container matColumnDef="noData">
                            <td mat-footer-cell *matFooterCellDef colspan="5">
                                <small>No se encontró ningún resultado</small>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayColumns;  sticky : true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="SelectRow(row, 'AGENTE')"
                            [ngClass]="{'highlightTableColor': selectedAgenteRowIndex == row.consecutivo }"> </tr>
                        <tr mat-footer-row *matFooterRowDef="['noData']"
                            [ngClass]="(tablaAgentes?.data?.length === 0) ? '':'ocultarPaginator'"></tr>
                    </table>
                    <mat-paginator #agentes [pageSizeOptions]="[3, 5, 10, 20, 50,100]" showFirstLastButtons
                        [pageSize]="3" [length]="tablaAgentes?.data?.length"
                        aria-label="Select page of periodic elements" [ocultarLabelPagina]="true"
                        [ocultarInputPagina]="true" appOcultaElementosPaginador>
                    </mat-paginator>
                </div>
            </div>
            <div class="col-md-12">
                <span class="contenedor-descripcion-convenio">{{selectAgenteDatos?.texto_conv}}</span>
            </div>
        </div>

    </div>
</div>